(ns frontend.test.html-table
  (:require [basic-components.html-table.table :as table]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [common.localization :as loc]
            [basic-components.inputs.footprint :refer [editor]]
            [frontend.logging :as logging]))

(defn date-cell-render [{:keys [column-meta cell-value row-data state]}]
  (session/long->tenant-date-time cell-value))

(def columns
  [{:column/key       :entity/type
    :column/label     (loc/tr :entity/type)
    :column/data-type :data.type/keyword
    :column/sortable  false}
   {:column/key       :db/id
    :column/label     (loc/tr :db/id)
    :column/data-type :data.type/id}
   {:column/key       :common/created-on
    :column/label     (loc/tr :common/created-on)
    ;:column/cell-renderer date-cell-render
    :column/data-type :data.type/datetime}
   {:column/key       :oppo/deal-description
    :column/label     (loc/tr :oppo/deal-description)
    :column/data-type :data.type/text-multiline}
   {:column/key       :common/disabled?
    :column/label     (loc/tr :common/disabled?)
    :column/data-type :data.type/boolean}
   {:column/key       :tenant/tenant-onboarding?
    :column/label     (loc/tr :tenant/tenant-onboarding?)
    :column/data-type :data.type/boolean}
   {:column/key       :person/universal-email-address
    :column/label     (loc/tr :person/universal-email-address)
    :column/data-type :data.type/text-url}
   {:column/key       :oppo/yield-indication-percentage
    :column/label     (loc/tr :oppo/yield-indication-percentage)
    :column/data-type :data.type/percentage}
   {:column/key       :person/first-name
    :column/label     (loc/tr :person/first-name)
    :column/data-type :data.type/text-simple}
   ])


(defmethod routing/render-view :test/html-table [{:keys [route-params]}]
  [:div
   {:class-name "p-4"}
   [:div
    [table/view
     (->> @session/all-accounts
          (sort-by :common/updated-on)
          (reverse)
          (take 20))
     {:id-key    :db/id
      :table-key "test-table"
      :columns   columns
      :settings  {:show-selection?        true
                  :show-filters?          true
                  :show-grouping?         true
                  :show-sorting?          true
                  :default-sort-key       :common/created-on
                  :column-order           [:db/id :entity/type :common/created-on]
                  :sticky-column-group    0
                  :filters                []
                  :on-selection-change-fn (fn [selected-ids]
                                            (logging/info "table selection " selected-ids))
                  :on-settings-change     (fn [table-settings]
                                            (logging/info "New table settings " table-settings))}}]]])
